import {
  playbookIdSchema,
  type PlaybookId,
} from "@repo/app-types/entities/playbook";
import { useMatch } from "react-router";
import { appPaths } from "../app/appPaths.js";

/**
 * The playbook the current URL is scoped to, for app chrome that renders
 * outside the route outlet (the research agent, the search dialog): those
 * components sit above the routes, so they read the playbook from the URL
 * rather than from props.
 *
 * `undefined` for every URL that doesn't carry a real playbook ID — including
 * the `default` placeholder segment, which the chrome renders alongside while
 * `DefaultPlaybookGate` resolves it to the teammate's playbook (see
 * `features/links/defaultPlaybookRedirect.tsx`). Chrome must treat that window
 * as "no playbook yet": the placeholder is not an ID to fetch by, to store on
 * a record, or to pass to `asPlaybookId`, which throws on it.
 */
export function usePlaybookIdParam(): PlaybookId | undefined {
  const playbookRouteMatch = useMatch(`${appPaths.playbook.pattern}/*`);
  return playbookIdSchema.safeParse(playbookRouteMatch?.params.playbookId).data;
}
